import React, { useRef } from "react";
import logo from "../images/logo.svg";

import "../style/Navbar.scss";

function Navbar() {
  const navbarRef = useRef(null);

  const toggleNavbar = () => {
    navbarRef.current.classList.toggle("navbar-open");
  };

  return (
    <div className="navbar wrapper" ref={navbarRef}>
      <img src={logo} alt="" className="logo" />

      <div className="navbar__link-container">
        <ul>
          <li>
            <a href="/#">Features</a>
          </li>
          <li>
            <a href="/#">Pricing</a>
          </li>
          <li>
            <a href="/#">Resources</a>
          </li>
        </ul>

        <div className="login-signup">
          <a href="/#">Login</a>
          <a href="/#" id="signup-btn">
            Sign up
          </a>
        </div>
      </div>

      <div className="burger" onClick={toggleNavbar}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
    </div>
  );
}

export default Navbar;
